// 未ログイン時トップ（LP）専用パック。layouts/lp が defer で読む。
// application.js から LP で使うものだけを同じ順序で require する（tops/landing_* は招待エラー画面用に application.js にも残す）。

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
require("jquery")
// loading.js は Rails.start() より先に評価する（confirm:complete の前提。loading.js のコメント参照）
require("loading.js")
require("components/toast.js")

require("tops/landing_reveal.js")
require("tops/landing_count_up.js")
require("tops/landing_carousel.js")
require("tops/landing_tabs.js")
require("tops/landing_hero_gallery.js")
require("tops/landing_mobile_cta.js")
require("tops/landing_faq.js")
require("tops/landing_html_scroll.js")

require("gtm.js")

// layouts/lp が preload で先に取得した Web フォントの CSS を適用する（描画をブロックしないため）
document.querySelectorAll('link[data-lp-web-font]').forEach((link) => {
  link.rel = 'stylesheet'
})

Rails.start()
Turbolinks.start()

// Register Service Worker (no offline caching)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service_worker.js').catch(() => {
      // Ignore registration errors silently
    });
  });
}
